<mat-card
  class="match-card"
  [routerLink]="['/statistics', 'match', match.match_id]"
  appearance="outlined">

  <div class="card-meta">
    <div class="meta-left">
      <span>{{ match.competition_name }}</span>
      <span *ngIf="match.match_day" class="match-day">
        | Jornada {{ match.match_day }}
      </span>
    </div>

    <div class="meta-right">
      <span>{{ match.match_date | date:'dd/MM/yyyy' }}</span>
    </div>
  </div>

  <div class="card-content">

    <div class="team team-local">
      <span class="team-name">{{ match.home_team_name }}</span>
    </div>

    <div class="score-container">
      <span class="score">{{ match.home_score }}</span>
      <span class="score-separator">-</span>
      <span class="score">{{ match.away_score }}</span>
    </div>

    <div class="team team-away">
      <span class="team-name">{{ match.away_team_name }}</span>
    </div>

  </div>

</mat-card>
